

import React, { useState, useEffect } from "react";
import axios from "axios";

const SummarySG = () => {
  const [data, setData] = useState([]);
  const [totalYield, setTotalYield] = useState({
    daily: 0,
    monthly: 0,
    yearly: 0,
    yearToDate: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      let fetchedData = [];
      let total = { daily: 0, monthly: 0, yearly: 0, yearToDate: 0 };

      const today = new Date();
      const currentDateFormatted = today.toISOString().split("T")[0];

      const mainPlants = ["32tuas", "36tuas", "40tuas", "80tuas", "15Tech", "73tuas"];
      const meterReadingPlants = [...mainPlants, "110tuas1", "110tuas2"];

      for (const plant of mainPlants) {
        try {
          const response = await axios.post("/v1/overview/station-real-kpi/", {
            plant,
            timeZone: currentDateFormatted,
          });

          let totalYield = 0;

          if (response.data.success && response.data.data) {
            totalYield = Number(response.data.data.cumulativeEnergy || 0);

            if (meterReadingPlants.includes(plant)) {
              try {
                const powerResponse = await axios.post("/api/lifetimetotalpower", { plant });
                const powerMetre = powerResponse.data.LifetimeTotalPower || 0;
                // const powerInMWh = powerMetre / 1000;
                const powerInMWh = (plant === "110tuas1" || plant === "110tuas2")
                   ? powerMetre : powerMetre / 1000;

                const powerYield = powerInMWh - totalYield;
                totalYield += powerYield;
              } catch (powerError) {
                console.error(`Error fetching LifetimeTotalPower for ${plant}:`, powerError);
              }
            }

            const daily = Number(response.data.data.dailyEnergy || 0);
            const monthly = Number(response.data.data.monthEnergy || 0);
            const yearly = Number(response.data.data.yearEnergy || 0);

            fetchedData.push({
              plant,
              daily,
              monthly,
              yearly,
              yearToDate: totalYield,
            });

            total.daily += daily;
            total.monthly += monthly;
            total.yearly += yearly;
            total.yearToDate += totalYield;
          }
        } catch (error) {
          console.error("Error fetching data for plant:", plant, error);
          fetchedData.push({ plant, daily: 0, monthly: 0, yearly: 0, yearToDate: 0 });
        }
      }

      // Combine data for 110tuas1 and 110tuas2
      const combinedGroup = ["110tuas1", "110tuas2"];
      let combined = { daily: 0, monthly: 0, yearly: 0, yearToDate: 0 };

      for (const plant of combinedGroup) {
        try {
          const response = await axios.post("/v1/overview/station-real-kpi/", {
            plant,
            timeZone: currentDateFormatted,
          });

          let totalYield = 0;

          if (response.data.success && response.data.data) {
            totalYield = Number(response.data.data.cumulativeEnergy || 0);

            // Apply meter reading adjustment
            if (meterReadingPlants.includes(plant)) {
              try {
                const powerResponse = await axios.post("/api/lifetimetotalpower", { plant });
                const powerMetre = powerResponse.data.LifetimeTotalPower || 0;
                 const powerInMWh = (plant === "110tuas1" || plant === "110tuas2")
      ? powerMetre
      : powerMetre / 1000;
                const powerYield = powerInMWh - totalYield;
                totalYield += powerYield;
              } catch (powerError) {
                console.error(`Error fetching LifetimeTotalPower for ${plant}:`, powerError);
              }
            }

            const daily = Number(response.data.data.dailyEnergy || 0);
            const monthly = Number(response.data.data.monthEnergy || 0);
            const yearly = Number(response.data.data.yearEnergy || 0);

            combined.daily += daily;
            combined.monthly += monthly;
            combined.yearly += yearly;
            combined.yearToDate += totalYield;
          }
        } catch (error) {
          console.error(`Error fetching data for ${plant}`, error);
        }
      }

      fetchedData.push({
        plant: "110 Tuas - (A + B)",
        daily: combined.daily,
        monthly: combined.monthly,
        yearly: combined.yearly,
        yearToDate: combined.yearToDate,
      });

      total.daily += combined.daily;
      total.monthly += combined.monthly;
      total.yearly += combined.yearly;
      total.yearToDate += combined.yearToDate;

      setData(fetchedData);
      setTotalYield(total);
    };

    fetchData();
  }, []);

  const getHeaderStyle = () => ({
    backgroundColor: 'grey',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '16px',
  });

  return (
    <div
      style={{
        marginTop: '40px',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#f9f9f9',
        overflowX: 'auto',
      }}
    >
      <h3 style={{ textAlign: 'center', marginTop: '20px' }}>
        Solar Plant Yield Overview
      </h3>

      <table
        border="1"
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          textAlign: 'center',
          fontFamily: "'Arial', sans-serif",
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <thead>
          <tr>
            <th style={getHeaderStyle()}>No</th>
            <th style={getHeaderStyle()}>Plant Name</th>
            <th style={getHeaderStyle()}>Daily Yield (kWh)</th>
            <th style={getHeaderStyle()}>Monthly Yield (MWh)</th>
            <th style={getHeaderStyle()}>Yearly Yield (MWh)</th>
            <th style={getHeaderStyle()}>Year to Date Yield (MWh)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white',
                cursor: 'pointer',
              }}
            >
              <td>{index + 1}</td>
              <td style={{ backgroundColor: "lightblue", fontWeight: "bold" }}>
                {item.plant === "32tuas" ? "32 Tuas"
                  : item.plant === "40tuas" ? "40 Tuas"
                  : item.plant === "36tuas" ? "36 Tuas"
                  : item.plant === "73tuas" ? "73 Tuas"
                  : item.plant === "80tuas" ? "80 Tuas"
                  : item.plant === "110 Tuas - (A + B)" ? "110 Tuas - (A + B)"
                  : item.plant}
              </td>
              <td>{item.daily.toFixed(2)}</td>
              <td>{item.monthly.toFixed(2)}</td>
              <td>{item.yearly.toFixed(2)}</td>
              <td>{Number(item.yearToDate || 0).toFixed(3)}</td>
            </tr>
          ))}
          <tr
            style={{
              backgroundColor: 'yellow',
              fontWeight: 'bold',
              fontSize: '16px',
              color: 'black',
            }}
          >
            <td colSpan="2">Total</td>
            <td>{totalYield.daily.toFixed(2)}</td>
            <td>{totalYield.monthly.toFixed(2)}</td>
            <td>{totalYield.yearly.toFixed(2)}</td>
            <td>{Number(totalYield.yearToDate || 0).toFixed(3)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SummarySG;
